<template>
  <div class="cp-about">
    <div class="row">
      <div class="columns">
        <!-- <div class="col column cp-about-image is-half">
          <img class="cp-about-logo" src="https://ik.imagekit.io/osusf6xvdf/beta/Gaiwow_Banner-01_yUrDBHRfADqX.jpg" />
        </div> -->
        <div class="col column">
          <!-- <p class="title is-5" :class="{ 'has-text-white':
          inverted }">{{ companyName }}</p> -->
          <hr v-if="!inverted" class="has-background-primary" />
          <hr v-if="inverted" class="has-background-white" />
          <p class="is-size-5" :class="{ 'has-text-white': inverted }">
            <span v-html="address"></span>
          </p>
          <!-- <div class="contact-section has-text-left">
              <p class="is-size-5 md-block" :class="{ 'has-text-white': inverted }">
                <img src="../assets/img/icon/icon-mail.png" class="contact-img">
                <span class="md-block-detail">{{ email }}</span>
              </p>
              <br />
              <p class="is-size-5 md-block" :class="{ 'has-text-white': inverted }">
                <img src="../assets/img/icon/icon-phone.png" class="contact-img">
                <span class="md-block-detail">{{ telephone }}</span>
              </p>
          </div> -->
          <div v-if="!inverted" class="cp-about-top-space"></div>
          <br />
          <br v-if="inverted" />
          <hr v-if="!inverted" class="has-background-primary" />
          <p class="is-size-5" :class="{ 'has-text-white': inverted }"></p>
          <div class="has-text-left">
              <a href="mailto:madamranee.official@gmail.com">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-31_xpUa9lq9uFi.png"
              class="contact-img-footer"></a>
              <!-- <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-32_YnRZIubDqxyR.png"
              class="contact-img-footer">
              <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-34_aeCjFz94SljM.png"
              class="contact-img-footer"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  props: {
    inverted: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: String,
      default: '',
    },
    logoWhite: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      default: '',
    },
    address: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    telephone: {
      type: String,
      default: '',
    },
    line: {
      type: String,
      default: '',
    },
    companyImage: {
      type: String,
      default: '',
    }
  },
};
</script>

<style lang="scss" scoped>
.md-block{
  display: inline-flex;
  &-detail{
    font-size: 15px;
  }
}
.contact-img{
  height:30px;
  width:auto;
  margin-right:10px;
  &-footer{
    margin-right:20px;
    height:40px;
    width:auto;
  }
}
.contact-section{
  margin-top: 2rem;
  line-height: 2;
  margin-bottom: -3rem;
}
.cp-about {
  text-align: left;
  @media screen and (max-width: 768px) {
    text-align: center;
  }
  &-image {
    text-align: center;
  }
  &-top-space {
    margin-top: 10px;
  }

  &-logo {
    height: 340px;
    width: 340px;
  }
}
</style>
